export const setVulnerabilityData=(vuldatalist)=>{
    return {
        type:"FETCH_VULNERABILITY_DATA",
        payload: vuldatalist
    }
}
